/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * One row of the credit-card-authorization queue: everything an operator needs to fill
 * out the property's auth form without opening the reservation first.
 *
 * @export
 * @interface CreditCardAuthReservation
 */
export interface CreditCardAuthReservation {
  /**
   *
   * @type {string}
   * @memberof CreditCardAuthReservation
   */
  bookingId: string;
  /**
   *
   * @type {string}
   * @memberof CreditCardAuthReservation
   */
  gondolaBookingId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreditCardAuthReservation
   */
  chainName?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreditCardAuthReservation
   */
  propertyName?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreditCardAuthReservation
   */
  checkIn?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreditCardAuthReservation
   */
  checkOut?: string | null;
  /**
   *
   * @type {number}
   * @memberof CreditCardAuthReservation
   */
  nights?: number | null;
  /**
   *
   * @type {string}
   * @memberof CreditCardAuthReservation
   */
  guestFirstName?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreditCardAuthReservation
   */
  guestLastName?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreditCardAuthReservation
   */
  confirmationNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreditCardAuthReservation
   */
  roomName?: string | null;
  /**
   * Total charge the authorization form needs to cover, incl. taxes and fees.
   * @type {number}
   * @memberof CreditCardAuthReservation
   */
  totalCost?: number | null;
  /**
   *
   * @type {string}
   * @memberof CreditCardAuthReservation
   */
  billingCurrency?: string | null;
  /**
   * Supplier path (DIRECT_MANUAL / DIRECT_AUTOMATIC / TRAVELPORT).
   * @type {string}
   * @memberof CreditCardAuthReservation
   */
  bookingProcess?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreditCardAuthReservation
   */
  status?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreditCardAuthReservation
   */
  createdAt?: string | null;
  /**
   * Whole days from today to check-in; 0 means arriving today. Drives queue urgency.
   * @type {number}
   * @memberof CreditCardAuthReservation
   */
  daysUntilCheckin?: number | null;
  /**
   * ISO-8601 timestamp when the authorization was requested from the property.
   * @type {string}
   * @memberof CreditCardAuthReservation
   */
  creditCardAuthRequested?: string | null;
  /**
   * ISO-8601 timestamp when submitted; null means outstanding.
   * @type {string}
   * @memberof CreditCardAuthReservation
   */
  creditCardAuthSubmitted?: string | null;
}

/**
 * Check if a given object implements the CreditCardAuthReservation interface.
 */
export function instanceOfCreditCardAuthReservation(
  value: object
): value is CreditCardAuthReservation {
  if (!("bookingId" in value) || value["bookingId"] === undefined) return false;
  return true;
}

export function CreditCardAuthReservationFromJSON(
  json: any
): CreditCardAuthReservation {
  return CreditCardAuthReservationFromJSONTyped(json, false);
}

export function CreditCardAuthReservationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreditCardAuthReservation {
  if (json == null) {
    return json;
  }
  return {
    bookingId: json["booking_id"],
    gondolaBookingId:
      json["gondola_booking_id"] == null
        ? undefined
        : json["gondola_booking_id"],
    chainName: json["chain_name"] == null ? undefined : json["chain_name"],
    propertyName:
      json["property_name"] == null ? undefined : json["property_name"],
    checkIn: json["check_in"] == null ? undefined : json["check_in"],
    checkOut: json["check_out"] == null ? undefined : json["check_out"],
    nights: json["nights"] == null ? undefined : json["nights"],
    guestFirstName:
      json["guest_first_name"] == null ? undefined : json["guest_first_name"],
    guestLastName:
      json["guest_last_name"] == null ? undefined : json["guest_last_name"],
    confirmationNumber:
      json["confirmation_number"] == null
        ? undefined
        : json["confirmation_number"],
    roomName: json["room_name"] == null ? undefined : json["room_name"],
    totalCost: json["total_cost"] == null ? undefined : json["total_cost"],
    billingCurrency:
      json["billing_currency"] == null ? undefined : json["billing_currency"],
    bookingProcess:
      json["booking_process"] == null ? undefined : json["booking_process"],
    status: json["status"] == null ? undefined : json["status"],
    createdAt: json["created_at"] == null ? undefined : json["created_at"],
    daysUntilCheckin:
      json["days_until_checkin"] == null
        ? undefined
        : json["days_until_checkin"],
    creditCardAuthRequested:
      json["credit_card_auth_requested"] == null
        ? undefined
        : json["credit_card_auth_requested"],
    creditCardAuthSubmitted:
      json["credit_card_auth_submitted"] == null
        ? undefined
        : json["credit_card_auth_submitted"],
  };
}

export function CreditCardAuthReservationToJSON(
  json: any
): CreditCardAuthReservation {
  return CreditCardAuthReservationToJSONTyped(json, false);
}

export function CreditCardAuthReservationToJSONTyped(
  value?: CreditCardAuthReservation | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    booking_id: value["bookingId"],
    gondola_booking_id: value["gondolaBookingId"],
    chain_name: value["chainName"],
    property_name: value["propertyName"],
    check_in: value["checkIn"],
    check_out: value["checkOut"],
    nights: value["nights"],
    guest_first_name: value["guestFirstName"],
    guest_last_name: value["guestLastName"],
    confirmation_number: value["confirmationNumber"],
    room_name: value["roomName"],
    total_cost: value["totalCost"],
    billing_currency: value["billingCurrency"],
    booking_process: value["bookingProcess"],
    status: value["status"],
    created_at: value["createdAt"],
    days_until_checkin: value["daysUntilCheckin"],
    credit_card_auth_requested: value["creditCardAuthRequested"],
    credit_card_auth_submitted: value["creditCardAuthSubmitted"],
  };
}
